import { Role, User } from '~/types';

export const is = (user: User, role: Role) =>
  user.roles.find(({ key }) => key === 'admin' || role === key) !== undefined;
